import {
    AfterViewInit,
    Component,
    ElementRef,
    EventEmitter,
    HostListener,
    Input,
    OnDestroy,
    OnInit,
    Output,
    ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject } from 'rxjs';
import { buffer, debounceTime, filter, map } from 'rxjs/operators';
import { DocumentManagerService } from '../../services/document-manager.service';
import { MyDrive, State } from '../document-list/document-list.component';
import { MatSnackBar } from '@angular/material/snack-bar';

@Component({
    selector: 'app-document-list-grid-view',
    templateUrl: './document-list-grid-view.component.html',
    styleUrls: ['./document-list-grid-view.component.scss']
})
export class DocumentListGridViewComponent
    implements OnInit, AfterViewInit, OnDestroy
{
    @Input() State: State;
    @Input() MyDrive: MyDrive;
    @Input() dmsConfig: any;
    @Input() UserId: any;
    @Output() SelectEvent = new EventEmitter<any>();
    sharedFolders = [];
    sharedFiles = [];
    @ViewChild('parentDiv') parentDiv: ElementRef;
    public RowBreakPoint = '20'; //lg
    clickStream: Subject<any> = new Subject<any>();

    constructor(
        private router: Router,
        private _DocumentManagerService: DocumentManagerService,
        private snackBar: MatSnackBar,
        private translateService: TranslateService
    ) {}

    public Actions = {
        Select: (Document, Type) => {
            // console.log("Select grid");

            const idx = this.State.SelectedItemIds.indexOf(Document.ItemId);
            if (idx == -1) {
                this.State.SelectedItemIds.splice(
                    this.State.SelectedItemIds.indexOf(Document.ItemId),
                    1
                );
                Document.Type = Type;
                this.SelectEvent.emit(Document);
            } else {
                this.State.SelectedItemIds.push(Document.ItemId);
                Document.Type = Type;
                this.SelectEvent.emit(Document);
            }
        },
        OnClickOutside: (i, event) => {
            // Keeping the document highlighted if information button is clicked
            let buttonId = '';
            if ('parentNode' in event.target) {
                if (event.target.parentNode.id) {
                    buttonId = event.target.parentNode.id;
                } else {
                    buttonId = event.target.id;
                }
            }
            if (event.value && buttonId === 'information-icon') {
                // this.State.SelectedItemId = '';
                // this.SelectEvent.emit('');
                return;
            }
            const infoIcon = document.querySelector('#information-section');
            if (event.value && !infoIcon.contains(event.target)) {
                this.State.SelectedItemIds = [];
                this.SelectEvent.emit('');
            }
        },
        DoNothing: () => {
            return false;
        },
        DoubleClicked: (_Document) => {
            if (this.dmsConfig.viewArchivedDoc) return;
            this.SelectEvent.emit('');
            if (
                _Document['Type'] === 'DriveFolder' ||
                _Document['Type'] === 'SharedFolder'
            ) {
                this._DocumentManagerService.FolderEvent.next(
                    _Document['ItemIds'][0]
                );
            } else if (
                _Document['Type'] === 'DriveFile' ||
                _Document['Type'] === 'SharedFile'
            ) {
                // this._DocumentManagerService.viewFile(_Document.ItemIds[0], true);
                // this._DocumentManagerService.downloadFile(_Document['ItemIds'][0].FileStorageId).then
            }
        },
        OnResized: ($event) => {
            const width = $event.newWidth;
            this.setRowBreakPoint(width);
        }
    };

    @HostListener('window:resize', ['$event'])
    onResize(event) {
        const width = event.target.innerWidth;
        this.setRowBreakPoint(width);
    }

    ngOnInit() {
        this.clickStream
            .pipe(
                buffer(this.clickStream.pipe(debounceTime(0))),
                map((list: any, type) => {
                    return {
                        ItemIds: list,
                        Length: list.length,
                        Type: list[0].Type
                    };
                }),
                filter((x) => x.Length === 1)
            )
            .subscribe((event) => {
                // console.log("Stream");

                // this.Actions.Select(event.ItemIds[0], event.Type);
                this.Actions.DoubleClicked(event);
            });
        /* this.clickStream
            .pipe(
                buffer(this.clickStream.pipe(debounceTime(250))),
                map((list: any) => {
                    return {
                        ItemIds: list,
                        Length: list.length,
                        Type: list[0].Type
                    };
                }),
                filter((x) => x.Length === 2)
            )
            .subscribe((event) => {
                // load Folder
                console.log(event);
                this.Actions.DoubleClicked(event);
            }); */
    }

    private getRowBreakPoint(breakpoint: string, defaultValue: string): string {
        if (this.dmsConfig && this.dmsConfig['RowBreakPoint'] && this.dmsConfig['RowBreakPoint'][breakpoint]) {
            return this.dmsConfig['RowBreakPoint'][breakpoint];
        }
        return defaultValue;
    }

    ngOnDestroy() {
        this._DocumentManagerService.FolderEvent.next('');
    }

    ngAfterViewInit(): void {
        setTimeout(() => {
            const width = this.parentDiv.nativeElement.clientWidth;
            this.setRowBreakPoint(width);
        });
    }

    setRowBreakPoint(width: number): void {
        if (width >= 0 && width <= 599) {
            this.RowBreakPoint = this.getRowBreakPoint('xs', '100'); // xs
        } else if (width >= 600 && width <= 1023) {
            this.RowBreakPoint = this.getRowBreakPoint('sm', '33'); // sm
        } else if (width >= 1024 && width <= 1439) {
            this.RowBreakPoint = this.getRowBreakPoint('md', '25'); // md
        } else if (width >= 1440) {
            this.RowBreakPoint = this.getRowBreakPoint('lg', '20'); // lg
        }
    }
    
    matSnackBarOpen(value, duration?: number) {
        const translateValue = this.translateService.instant(value);
        this.snackBar.open(translateValue, null, {
            duration: duration || 3000,
            verticalPosition: 'top',
            horizontalPosition: 'end',
            panelClass: 'custom-snackbar'
        });
    }
}
